import {Action, getModule, Module, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {RecoverMainRequestType} from "@/form/recover/recoverMain/recoverMain.types";
import {RecoverCodeRequestType} from "@/form/recover/recoverCode/recoverCode.types";
import {RecoverPasswordRequestType} from "@/form/recover/recoverPassword/recoverPassword.types";
import {ResponseDataType} from "@/form/form.types";


@Module({
    namespaced: true,
    name: 'recover',
    store,
    dynamic: true,
})
class RecoverModule extends VuexModule {

    @Action({rawError: true})
    async sendCode(data: RecoverCodeRequestType): Promise<ResponseDataType> {
        const response = await store.$repository.recover.sendCode(data);
        return response;
    }

    @Action({rawError: true})
    async checkCode(data: RecoverMainRequestType): Promise<ResponseDataType> {
        const response = await store.$repository.recover.checkCode(data);
        return response;
    }

    @Action({rawError: true})
    async recoverDo(data: RecoverPasswordRequestType): Promise<ResponseDataType> {
        const response = await store.$repository.recover.recoverDo(data);
        return response;
    }
}

export const RecoverStore = getModule(RecoverModule);
